<div class="fullcontainer" >
    <br />
    <br />
  
    <div class='titleContainer'>
      <h2 class='header' >All Yard Trade</h2>
      <div>
        <button class='btn btn-secondary' routerLink='/weighbridge/yard-trade/'><i class="fas fa-plus"></i> New</button>&nbsp;
      </div>
    </div>
    <br />
    <br />
    <app-grid
  entity='yard-trade'
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFilters'
  [searchFields]='this.searchFields'
  [relationships]='["yardTradePricing", "grade"]'
  ></app-grid>
  